import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { colors } from '../../styles/colors'

import { CartIco } from './CartIco'
import { ConsultationButton } from '../UI/ConsultationButton'
import { BurgerMenuIco } from './BurgerMenuIco'
import { SearchBar } from './SearchBar'
import { MobileMenu } from './MobileMenu'

import { getStringWithUpperFirstChar } from '../../functions/getStringWithUpperFirstChar'
import { getFormatedData } from '../../functions/getFormatedData'
import { getRootCategories } from '../../functions/getRootCategories'
import { getFormatedTel } from '../../functions/getFormatedTel'

import logo from '../../img/logo.png'

const Container = styled.section`
    position: relative;
    border-bottom: 1px solid ${colors.dark_blue};

    a {
        font-family: 'Lato', sans-serif;
        font-size: 2.5rem;
        font-weight: 300;
        text-decoration: none;
        text-align: center;
        color: ${colors.dark_blue};

        :hover {
            color: ${colors.red};
        }
    }
    .link-active {
        color: ${colors.red};
    }

    .nav {
        max-width: 1920px;
        height: 17.5rem;

        margin: 0 auto;
        padding: 0 4rem;

        display: flex;
        justify-content: space-between;
        align-items: center;

    }
    
    .logo {
        width: 100px;
        height: 100px;
        background: url(${logo}) no-repeat 50% 50% ;
        background-size: cover;
        margin-right: ${props => props.searching_focused ? '4rem' : '0'};
    
        @media (max-width: 768px) {
            width: 60px;
            height: 60px;
            display: ${props => props.searching_focused ? 'none' : 'block'};
        }
    }

    .hide-on-search-bar-focused {
        white-space: nowrap;
        display: ${props => props.searching_focused ? 'none' : 'block'};
    }

    .products-navlink {
        svg {
            margin-left: 0.5rem;
            position: relative;
            top: -2px;
        }
        :hover {
            svg path {
                fill: ${colors.red};
            }
        }
    }

    .searchbar-wrapper {
        width: ${props => props.searching_focused ? '100%' : '30px'};
    }

    @media (min-width: 767.98px) and (max-width: 1199.98px ) {     
        .home-navlink,
        .products-navlink,
        .service-navlink,
        .contacts-navlink,
        .phone-navlink {
            display: none;
        }    
    }
    @media (max-width: 768px) {
        .nav {
            height: 18.75rem;
        }
        .home-navlink,
        .products-navlink,
        .service-navlink,
        .contacts-navlink,
        .phone-navlink,
        .consultation-navlink {
            display: none;
        }
    
    }
`;
const Subnavigation = styled.div`
    display: ${props => props.submenu_active === true ? 'block' : 'none'} ;
    width: 100vw;

    background: #fff;
    border-top: 1px solid ${colors.dark_blue};

    position: absolute;
    top: 17.5rem;
    z-index: 2;

    .width-limiter {
        display: flex;
        justify-content: space-evenly;
        padding: 3.75rem 2rem 7.5rem 2rem;
    
    }
    .navigation_sublink {
        max-width: 300px;
        text-align: center;
    }


`;

export const Header = () => {

    const dispatch = useDispatch()

    const [submenuActive, setSubmenuActive] = useState(false)
    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const root_categories = getRootCategories(categories)
    const searching_focused = useSelector(state => state.searching.focused)
    const main_data = useSelector(state => state.firebase.data.main_data )
    
    const mobile_menu_opened = useSelector(state => state.menu.mobile_menu_opened)

    function closeSubmenu() {
        setSubmenuActive(false)
    }
    function handleSubmenu() {
        if(submenuActive === false) {
            setSubmenuActive(true)
        }
    }

    if (main_data) {
        getFormatedTel(main_data.tel)
    }

    function handleConsultationButtonClick () {
        dispatch({ type: 'CONSULTATION_FORM_OPENED' })
    }

    return (
        <Container searching_focused={searching_focused}>

            { mobile_menu_opened ? <MobileMenu /> : null}

            <nav className='nav'>
                <Link to='/' onMouseEnter={closeSubmenu} ><div className={'logo'} /></Link>
                <NavLink activeClassName='link-active' className='hide-on-search-bar-focused home-navlink' exact to='/' onMouseEnter={closeSubmenu} >Главная</NavLink>
                <Link className='hide-on-search-bar-focused products-navlink ' to='/products' onMouseEnter={() => handleSubmenu()} >
                    Продукция
                    <svg  width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 6L0.669875 0.75L9.33013 0.750001L5 6Z" fill="#00253D" />
                    </svg>
                </Link>
                <NavLink activeClassName='link-active' className='hide-on-search-bar-focused service-navlink' to='/service' onMouseEnter={closeSubmenu} >Сервисное <br/> обслуживание</NavLink>
                <NavLink activeClassName='link-active' className='hide-on-search-bar-focused contacts-navlink' to='/contacts' onMouseEnter={closeSubmenu} >Контакты</NavLink>
                <a className='hide-on-search-bar-focused phone-navlink' href={ main_data ? `tel:+${getFormatedTel(main_data.tel)}` : '#' } onMouseEnter={closeSubmenu} > { main_data ? main_data.tel : null } </a>
                <div className='hide-on-search-bar-focused consultation-navlink' onClick={ handleConsultationButtonClick } onMouseEnter={closeSubmenu} ><ConsultationButton /></div>
                <Link className='hide-on-search-bar-focused ' to='/cart' onMouseEnter={closeSubmenu} ><CartIco /></Link>
                <BurgerMenuIco />
                <div className='searchbar-wrapper' onMouseEnter={closeSubmenu} ><SearchBar  /></div>
                
                
            </nav>

            <Subnavigation id='subnavigation' submenu_active={submenuActive} onMouseLeave={()=> setSubmenuActive(false)} onClick={()=> setSubmenuActive(false)} >
                <div className="width-limiter" >
                    {
                        root_categories.length !== 0
                            ? root_categories
                                .map(item => (
                                    <NavLink activeClassName='link-active' to={`/products/${item.category_name}`} key={item.key} className='navigation_sublink' >
                                        {getStringWithUpperFirstChar(item.category_name)}
                                    </NavLink>
                                ))
                            : 'Что то пошло не так :( Попробуйте перезагрузить страницу'
                    }
                </div>
            </Subnavigation>

        </Container>
    )
}
